import { render } from "./SmartClassroom.vue?vue&type=template&id=d5700ca4&scoped=true"
import script from "./SmartClassroom.vue?vue&type=script&lang=js"
export * from "./SmartClassroom.vue?vue&type=script&lang=js"

import "./SmartClassroom.vue?vue&type=style&index=0&id=d5700ca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5700ca4"]])

export default __exports__